<template>
  <div class="Home">
    <SideBar></SideBar>

    <!-- 版心 -->
    <div class="_center">
      <!-- 切换显示内容 -->
      <div class="conent WidCon">
        <div class="conent_box">
          <h3>平台优势</h3>
          <i class="selected"></i>
          <div class="_text">打破专业建设壁垒，培养复合型应用人才</div>
          <ul class="personnel">
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform1.png" alt="" />
              </div>
              <div class="personnel2">
                <h3>课程体系接轨行业</h3>
                <p>
                  结合企业产业需求，规划系统的课程体系，<br />全面培养学生结构化能力，跨专业融合共享。
                </p>
              </div>
            </li>
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform2.png" alt="" />
              </div>
              <div class="personnel2">
                <h3>构建主流实训环境</h3>
                <p>灵活部署，快速构建主流AI场景及实训环境，<br />实现教学数字化转身。</p>
              </div>
            </li>
            <li>
              <div class="personnel1">
                <img src="@/zh-website/src/assets/platform3.png" alt="" />
              </div>
              <div class="personnel2">
                <h3>融入华为原厂技术</h3>
                <p>
                  基于华为原厂核心技术研发实训平台，<br />实训项目全、资金投入低，充分挖掘设备性能。
                </p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 平台资源 -->
        <div class="conent_box resources">
          <h3>平台资源</h3>
          <i class="selected"></i>
          <!-- 课程 -->
          <div class="course">
            <div class="course_box">
              <h3>平台课程资源</h3>
              <p>丰富的人工智能课程，满足学校人工智能专业课程开设需求</p>
              <ul class="form_box">
                <li>
                  <div>
                    <i></i>
                    <p>7 门人工智能专业基础课</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i></i>
                    <p>6 门人工智能专业核心课</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i></i>
                    <p>9 门人工智能实战案例</p>
                  </div>
                </li>
                <li>
                  <div>
                    <i></i>
                    <p>4 门人工智能认证课程</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="course_img">
              <div class="pink"></div>
              <img src="@/zh-website/src/assets/intelligent.png" alt="" />
            </div>
          </div>
          <!-- 环境 -->
          <div class="surroundings">
            <h3>实训室环境资源</h3>
            <p>华为原厂核心技术，配置主流运行场景，优化实验教学效果</p>
            <ul class="application">
              <li>
                <div>全场景：</div>
                <div>
                  智能无所不及，包括公有云、私有云、各种边缘计算、物联网终端及消费类终端等部署环境。
                </div>
              </li>
              <li>
                <div>全栈：</div>
                <div>
                  为AI开发者提供强大的算力和应用开发平台，包括芯片、芯片使能、训练和推理框架和应用使能。
                </div>
              </li>
            </ul>
          </div>
          <!-- 开发工具 -->
          <ul class="open">
            <li v-for="item in picList" :key="item">
              <div class="open_">
                <!-- <pic-zoom
                  :url="item.img"
                  :bigWidth="150"
                  :scale="3"
                  overlayStyle=" width:100%;height: 100%;border-radius: 3px;"
                ></pic-zoom> -->
                <img :src="item.img" alt="" />
                <p>{{ item.p }}</p>
              </div>

              <!-- 开发工具介绍 -->
              <div class="introduction">
                <h4>{{ item.p1 }}</h4>
                <p>{{ item.p2 }}</p>
              </div>
            </li>
          </ul>

          <!-- 网站 -->
          <div class="website">
            <div class="website_head">
              支持主流人工智能开源框架与工具库，玩转人工智能开源世界
            </div>
            <div class="website_box">
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo1.png" alt="" />
                </div>
                <p>R语言</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo2.png" alt="" />
                </div>
                <p>OpenCV</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo3.png" alt="" />
                </div>
                <p>python</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo4.png" alt="" />
                </div>
                <p>pandas</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo5.png" alt="" />
                </div>
                <p>Matplotlib</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo6.png" alt="" />
                </div>
                <p>TensorFlow</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo7.png" alt="" />
                </div>
                <p>git</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo8.png" alt="" />
                </div>
                <p>Vim</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo9.png" alt="" />
                </div>
                <p>Scikit-learn</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo10.png" alt="" />
                </div>
                <p>seaborn</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo11.png" alt="" />
                </div>
                <p>anaconda</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo12.png" alt="" />
                </div>
                <p>NumPy</p>
              </div>
              <div class="web">
                <div class="website_box_git">
                  <img src="@/zh-website/src/assets/logo13.png" alt="" />
                </div>
                <p>python</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 平台支撑 -->
        <div class="conent_box support">
          <h3>平台支撑</h3>
          <i class="selected"></i>
          <div class="_text red">打造混合云模式的最佳用户实验体验</div>
          <ul class="support_box">
            <li>
              <img src="@/zh-website/src/assets/cloud1.png" alt="" />
              <div>
                <h3>华为公有云平台</h3>
                <p>
                  免部署、免维护、省成本<br />
                  无需本地物理实训环境<br />
                  支持随时随地访问
                </p>
              </div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/cloud2.png" alt="" />
              <div>
                <h3>华为公有云平台+学校私有云平台</h3>
                <p>
                  支持公有云与私有云的平滑迁移<br />
                  充分利用学校本地实训资源
                  <br />
                  支持随时随地访问
                </p>
              </div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/cloud3.png" alt="" />
              <div>
                <h3>学校私有云平台</h3>
                <p>
                  保留公有云融合接口，方便扩展
                  <br />
                  提高学校硬件利用率
                  <br />
                  支持随时随地访问
                </p>
              </div>
            </li>
          </ul>

          <div class="_text red">可视可追溯的在线实验解决方案，提升实训教学效果</div>
          <h4>快速部署归档</h4>
          <p class="support_p">录入与导出实验手册，记录学习数据，调用计算环境</p>
          <div class="support_img">
            <img src="@/zh-website/src/assets/archive.png" alt="" />
            <div class="advantage">
              <div class="advantage_left">
                <h5>随时动手练习</h5>
                <div>
                  支持虚拟化/容器技术，利用现有设备及云资源，<br />打造在线实验环境
                </div>
              </div>
              <div class="advantage_right">
                <h5>过程追踪分析</h5>
                <div>
                  无缝呈现手册和代码，直接调试和运行代码并查看运行结
                  果，支持查看文字、图像、音频和视频等资源。
                </div>
              </div>
            </div>
            <div class="advantage">
              <div class="advantage_left advantage_left_1">
                <h5>打破时空限制</h5>
                <div>
                  一个平台可进行多种技术实验，课程与实验设计符合院校教学逻辑，轻松管理课程资源与实验资源
                </div>
              </div>
              <div class="advantage_right advantage_right_1">
                <h5>平台设计聚焦客户体验</h5>
                <div>根据客户需求设定客户行为库，<br />根据客户需求驱动平台设计。</div>
              </div>
            </div>
            <div class="advantage">
              <div class="advantage_left">
                <h5>支持多人协同、桌面分享</h5>
                <div>支持B/S架构，真正实现“任何人、任何时间、<br />任何地点”开展实验</div>
              </div>
              <div class="advantage_right">
                <h5>自动测评</h5>
                <div>减轻教师工作量，提高学生工程实践能力，<br />加强过程性跟踪。</div>
              </div>
            </div>
          </div>
          <h4 class="support_h4">智能配备资源</h4>
          <p class="support_p support_pb">
            根据客户对时间、价格的要求按需搭配组合资源配比
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";
  // import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
  // import PicZoom from "@/components/Common/PicZoom";
@Component({
  components: {
    // Banner,
    // PicZoom
  }
})
export default class Experiment extends Vue {
  picList= [
        {
          img: require("@/zh-website/src/assets/openAi.png"),
          p: "华为AI开发平台ModelArts",
          p1: "让AI 开发更简单",
          p2:
            "ModelArts是面向AI开发者的一站式开发平台，提供海量数据预处理及半自动化标注、大规模分布式训练、自动化模型生成及端-边-云模型按需部署能力，帮助用户快速创建和部署模型，管理全周期AI工作流。",
        },
        {
          img: require("@/zh-website/src/assets/open.png"),
          p: "Atlas 200开发者套件",
          p1: "让实验场景更丰富",
          p2:
            "华为Atlas 200 DK AI开发者套件是以昇腾310芯片为核心的一个开发者板形态产品，帮助AI应用的开发者快速熟悉开发环境。其主要功能是将昇腾310芯片的核心功能通过该板上的外围接口开放出来，方便用户快速简捷的接入并使用昇腾310芯片强大的处理能力。",
        },
        // {
        //   img: require("@/zh-website/src/assets/openKit.png"),
        //   p: "华为HiLens Kit",
        //   p1: "让应用落地更高效",
        //   p2:
        //     "云端训练，端侧部署。提供模型训练、开发、调试、部署、管理一站式服务，无缝对接用户设备。技能开发完成后可发布到技能市场或直接部署到端侧设备。",
        // },
      ]
      // 背景图样式文案
      list={
        style: {
          "background-image": `url(${require("@/zh-website/src/assets/banner_certification.png")})`,
          height: "493px",
        },
        font1: "人工智能专业建设",
        font2: "",
        font3: "",
        font4: "全场景、端到端",
        font5: "培养智能时代智慧人才",
        button: "",
      }
}



</script>
<style lang="less" scoped>
p {
  padding-top: 10px;
}
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
  max-width: 1366px;
  margin: 0 auto;
}
.conent_box {
  background-color: #f8f8f8;
  padding: 2.8125rem 0 0;
  margin-bottom: 1.25rem;
  h3 {
    font-size: 1.75rem;
    text-align: center;
    color: #333;
  }
  .selected {
    display: block;
    width: 1.5625rem;
    height: 0.1875rem;
    background-color: #333333;
    margin: 0.625rem auto 0;
  }
  ._text {
    width: 100%;
    text-align: center;
    color: #999999;
    margin: 1.25rem auto 1.875rem;
  }
  // 平台优势
  .personnel {
    display: flex;
    padding: 0 10.9375rem 4.0625rem;
    justify-content: space-between;
    li {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 16.5625rem;
      width: 20.1875rem;
      align-items: center;
      padding: 0 10px 0;
      color: #333;
      border: 1px solid #ccc;
      .personnel1 {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-bottom: 1.5rem;
        img {
          width: 4.1875rem;
        }
      }
      .personnel2 {
        flex: 1;
        display: flex;
        flex-direction: column;
        h3 {
          font-size: 1.25rem;
          font-weight: 700;
          // padding-top: 0.875rem;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #acacac;
          line-height: 160%;
          padding-top: 10px;
        }
      }
    }
  }
}
// 平台资源
.resources {
  padding: 2.8125rem 5.625rem 0;
  // 课程
  .course {
    margin-top: 5rem;
    display: flex;
    .course_box {
      display: flex;
      flex-direction: column;
      margin: 5rem 7% 0 0;
      flex: 1;
      font-size: 1.5rem;
      h3 {
        text-align: left;
        font-size: 1.5rem;
        font-weight: 700;
      }
      p {
        font-size: 1.125rem;
        color: #999;
        padding-top: 10px;
      }
      .form_box {
        li {
          padding-top: 1.25rem;
          font-size: 1.125rem;
          div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            i {
              display: inline-block;
              width: 0.1875rem;
              height: 0.1875rem;
              background-color: #dd0011;
              border-radius: 50%;
              margin-top: 22px;
            }
            p {
              width: 98%;
              color: #333;
            }
          }
        }
      }
    }
    .course_img {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      position: relative;
      overflow: hidden;
      margin-left: 20px;
      .pink {
        width: 100%;
        height: 100%;
        background-color: pink;
      }
      img {
        position: absolute;
        top: 2.5rem;
        right: 2.5rem;
        width: 100%;
        height: 100%;
      }
    }
  }
  // 环境
  .surroundings {
    display: flex;
    flex-direction: column;
    margin-top: 5rem;
    flex: 1;
    font-size: 1.5rem;
    h3 {
      text-align: left;
      font-size: 1.5rem;
      font-weight: 700;
    }
    p {
      font-size: 1.125rem;
      // font-weight: 700;
      // color: #dd0011;
    }
    .application {
      font-size: 1rem;

      color: #fff;
      display: flex;
      justify-content: space-between;
      li {
        background: url("../../../../assets/application.png") no-repeat center center;
        background-size: contain;
        width: 100%;
        height: 5.875rem;
        display: flex;
        padding: 1.3rem 1.875rem;
        margin: 1.875rem 0;
        &:nth-child(1) {
          margin-right: 10px;
        }
        &:nth-child(2) {
          margin-left: 10px;
        }
        div:nth-child(2) {
          // padding-left: 0.3125rem;
          flex: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  // 开发工具
  .open {
    display: flex;
    justify-content: space-between;
    li {
      width: 22.6875rem;
      &:nth-child(3) {
        img {
          width: 100%;
        }
      }
      .open_ {
        width: 100%;
        height: 15.8125rem;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        justify-content: flex-end;
        border-radius: 0.3125rem;
        box-shadow: 0 0 3px 1px #ccc;
        padding: 1.75rem 0;
        img {
          height: 90%;
          margin: 0 auto;
          width: 100%;
        }
        p {
          font-size: 1.125rem;
          text-align: center;
          color: #333333;
          font-weight: 700;
        }
      }
      // 开发工具介绍
      .introduction {
        display: flex;
        width: 22.6875rem;
        height: 12.5rem;
        flex-direction: column;
        padding-top: 1.875rem;
        h4 {
          font-size: 1.5rem;
          margin: 0;
          text-align: center;
        }
        p {
          font-size: 0.875rem;
          color: #333333;
          padding: 1.125rem 0;
          text-align: justify;
        }
      }
    }
  }

  // 主流网站
  .website {
    font-size: 1.125rem;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    .website_head {
      color: #dd0011;
      padding-top: 20px;
      font-size: 1.125rem;
      font-weight: 700;
      color: #dd0011;
    }
    .website_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 1.5625rem 0 1.25rem;
      .web {
        .website_box_git {
          width: 13rem;
          height: 7.3125rem;
          background-color: #fff;
          margin-right: 1.25rem;
          border-radius: 0.3125rem;
          img {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        p {
          text-align: center;
          font-weight: 400;
          padding: 1.25rem 0 1.875rem;
        }
      }
    }
  }
}
// 平台支撑
.support {
  padding: 2.8125rem 10px 0;
  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }
  .red {
    color: #ea2738;
    font-weight: 600;
  }
  .support_box {
    padding: 0 4.375rem;
    display: flex;
    justify-content: space-between;
    margin-bottom: 46px;
    li {
      width: 25rem;
      height: 13.3125rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      img {
        width: 4.3125rem;
        height: 2.75rem;
      }
      div {
        h3 {
          font-size: 1.5rem;
          color: #333;
        }
        p {
          font-size: 0.875rem;
          text-align: center;
          color: #555555;
        }
      }
    }
  }
  h4 {
    text-align: center;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .support_h4 {
    margin-top: 50px;
    color: #333;
  }
  .support_p {
    text-align: center;
  }
  .support_pb {
    text-align: center;
    padding-bottom: 60px;
  }
  .support_img {
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .advantage {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    h5 {
      font-size: 1.25rem;
      font-weight: 600;
      color: #333;
    }
    .advantage_left {
      width: 34.1875rem;
      margin-top: 2.125rem;
      padding-right: 9rem;
      display: flex;
      flex-direction: column;
      text-align: right;
    }
    .advantage_right {
      width: 36.375rem;
      margin-top: 2.125rem;
      padding-left: 11rem;
      display: flex;
      flex-direction: column;
    }
    .advantage_right_1 {
      padding-left: 14rem;
      margin-top: 35px;
    }
    .advantage_left_1 {
      padding-right: 12rem;
      margin-top: 35px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
  .conent_box .personnel {
    padding: 0 100px 4.0625rem;
  }
  .resources .open li {
    width: 30%;
  }
  .resources .open li .introduction {
    width: 100%;
  }
  .support .support_box li {
    width: 33%;
  }
  .support .support_box li div h3 {
    font-size: 22px;
  }
}
@media screen and (max-width: 1200px) and (min-width: 901px) {
  .conent .resources .course .course_img {
    display: none;
  }
  .resources .website .website_head {
    padding-top: 50px;
  }
  // .conent .developing_box .developing {
  //   flex-wrap: wrap;
  // }
  // .conent .developing_box .developing li {
  //   border: none;
  // }
  .resources .course {
    margin: 0;
  }
}
@media screen and (max-width: 985px) and (min-width: 769px) {
  .conent .resources .course .course_img {
    display: none;
  }
  .resources .course {
    margin: 0;
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  .conent_box {
    padding-top: 10px;
    ._text {
      margin: 10px auto 20px;
      font-size: 16px;
    }
    // 平台优势
    .personnel {
      padding: 0;
      padding-bottom: 10px;
      flex-direction: column;
      align-items: center;
      li {
        margin-bottom: 5px;
      }
    }
  }
  // 平台资源
  .resources {
    padding: 20px 1rem 0;
    // 课程
    .course {
      margin-top: 0;
      flex-direction: column;
      .course_box {
        margin: 20px 30px 0 0;
        p {
          margin: 0;
          font-size: 14px;
        }
        .form_box {
          li {
            padding: 0;
          }
        }
      }
      .course_img {
        margin-top: 0.625rem;
        .pink {
          width: 23rem;
          height: 18rem;
        }
        img {
          width: 23rem;
          height: 18rem;
          top: 1.5rem;
          right: 1.5rem;
        }
      }
    }
    // 环境
    .surroundings {
      margin-top: 3rem;
      .application {
        flex-direction: column;
        height: 100%;
        justify-content: start;
        li {
          margin: 0 auto;
          width: 100%;
          height: 100%;
          &:nth-child(2) {
            margin: 0;
          }
        }
      }
    }
    // 开发工具
    .open {
      width: 100%;
      overflow: hidden;
      flex-direction: column;
      align-items: center;
      li {
        width: 100%;
        margin: 0.625rem auto;
        .open_ {
          width: 100%;
          overflow: hidden;
        }
        // 开发工具介绍
        .introduction {
          height: 100%;
          flex-direction: column;
        }
      }
    }
    // 主流网站
    .website {
      .website_head {
        padding-top: 5px;
        font-size: 16px;
      }
      .website_box {
        justify-content: space-between;
        .web {
          width: 49%;
          .website_box_git {
            margin: 0;
            width: 100%;
          }
          &:nth-child(n + 3) img {
            width: 75% !important;
          }
          p {
            padding: 10px 20px;
          }
        }
      }
    }
  }
  // 平台支撑
  .support {
    h4 {
      font-size: 16px;
    }
    .support_p {
      font-size: 14px;
    }
    .support_box {
      flex-direction: column;
      align-items: center;
      padding: 0;
      li {
        margin-top: 5px;
        width: 100%;
      }
    }
    .support_img {
      img {
        opacity: 0;
      }
    }
    .advantage {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .advantage_left {
        width: 100%;
        text-align: center;
        padding: 0;
        h5 {
          font-size: 16px;
        }
        div {
          font-size: 14px;
        }
      }
      .advantage_right {
        width: 100%;
        text-align: center;
        padding: 0;
        h5 {
          font-size: 16px;
        }
        div {
          font-size: 14px;
        }
      }
      .advantage_right_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
      .advantage_left_1 {
        width: 100%;
        text-align: center;
        padding: 0;
      }
    }
  }

  .conent_box h3 {
    font-size: 18px;
  }

  .resources .course .course_box h3 {
    font-size: 16px;
  }

  .resources .surroundings h3 {
    font-size: 16px;
  }

  .resources .surroundings p {
    font-size: 14px;
  }

  .surroundings .application li div {
    font-size: 14px;
  }

  .resources .open li .introduction h4 {
    font-size: 18px;
  }

  .resources .open li .introduction p {
    margin: 0;
  }
  .support .support_box li div h3 {
    font-size: 16px;
  }

  .resources .course .course_img .pink {
    display: none;
  }

  .resources .course .course_img img {
    display: none;
  }

  .conent_box {
    padding-top: 20px;
  }
}
</style>
